<!-- <div class="fx-row align-items-center justify-content-between">
    <span class="text light">{{'DOCUMENT.ORDER_POSSIBILITY' | translate}}</span>
</div> -->
<div class="fx-row w-100 align-items-center justify-content-between mt-8">
    <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <mat-icon [class.red]="!possibility" [class.green]="possibility" class="mr-5" fontSet="material-icons-outlined"
            inset inline>{{possibility ?
            'check_circle' :
            'cancel'}}</mat-icon>
        <span class="small fx-flex">{{ (possibility ? 'DOCUMENT.ORDER_POSSIBILITY_ENABLED' :
            'DOCUMENT.ORDER_POSSIBILITY_DISABLED') | translate}}</span>
    </div>

    <app-metadata-confidence *ngIf="possibility" class="ml-20" [value]="getConfidence()"></app-metadata-confidence>
</div>